module.exports = __webpack_public_path__ + "static/media/icon_edit_light.581267a5.svg";